'use client';

import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';

export default function SiteFooter() {
  const [year, setYear] = useState(2025);

  useEffect(() => {
    setYear(new Date()?.getFullYear());
  }, []);

  return (
    <footer className="bg-card border-t border-border mt-16">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div className="sm:col-span-1">
            <div className="flex items-center gap-2 mb-3">
              <AppLogo size={28} />
              <span className="font-extrabold text-base tracking-tight text-foreground">iBrain Academy</span>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-xs">
              AI-guided adaptive learning that adapts to your pace. Real understanding, not just memorization.
            </p>
          </div>

          {/* Platform */}
          <div>
            <h4 className="text-xs font-semibold text-foreground uppercase tracking-widest mb-3">Platform</h4>
            <ul className="space-y-2">
              <li>
                <Link href="/" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Subjects
                </Link>
              </li>
              <li>
                <Link href="/profile" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  My Profile
                </Link>
              </li>
              <li>
                <Link href="/login" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Sign In
                </Link>
              </li>
              <li>
                <Link href="/register" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Enroll
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-xs font-semibold text-foreground uppercase tracking-widest mb-3">Company</h4>
            <ul className="space-y-2">
              <li className="text-sm text-muted-foreground">Jawelt Bay GmbH</li>
              <li>
                <a
                  href="mailto:hello@ibrain.academy"
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  hello@ibrain.academy
                </a>
              </li>
              <li>
                <Link href="/imprint" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Imprint
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-6 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-muted-foreground text-center sm:text-left">
            © {year} <span className="font-semibold text-foreground">Jawelt Bay GmbH</span>. All rights reserved.
            iBrain Academy is a product of Jawelt Bay GmbH.
          </p>
          <div className="flex items-center gap-3 text-xs text-muted-foreground">
            <Link href="/imprint" className="hover:text-foreground transition-colors">
              Imprint
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
